import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns is-centered is-hidden-mobile" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "steps" }
const _hoisted_5 = { class: "step-item is-completed is-info" }
const _hoisted_6 = { class: "step-marker" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "step-item is-info is-completed" }
const _hoisted_9 = { class: "step-marker" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = { class: "step-item is-info is-active" }
const _hoisted_12 = { class: "step-marker" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "columns" }
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "columns" }
const _hoisted_17 = { class: "column is-8" }
const _hoisted_18 = { class: "is-grey-background" }
const _hoisted_19 = { class: "columns" }
const _hoisted_20 = { class: "column" }
const _hoisted_21 = { class: "column has-vertical-bar" }
const _hoisted_22 = { class: "columns" }
const _hoisted_23 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_page = _resolveComponent("login-page")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_o_icon, { icon: "check" })
              ])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "step-details" }, [
              _createElementVNode("p", { class: "step-title" }, "Search")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_o_icon, { icon: "check" })
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "step-details" }, [
              _createElementVNode("p", { class: "step-title" }, "Citations")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_o_icon, { icon: "circle-small" })
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "step-details" }, [
              _createElementVNode("p", { class: "step-title" }, "Pay Bill")
            ], -1))
          ])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "columns" }, [
      _createElementVNode("div", { class: "column" }, [
        _createElementVNode("h1", { class: "title is-4 is-spaced" }, "Pay Bill")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, { to: "/results" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_icon, { icon: "arrow-left" }),
            _cache[3] || (_cache[3] = _createTextVNode(" Back", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "columns" }, [
      _createElementVNode("div", { class: "column" }, [
        _createElementVNode("p", { class: "" }, "How would you like to pay this bill?")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_login_page, { partial: "" })
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "columns" }, [
                _createElementVNode("div", { class: "column" }, [
                  _createElementVNode("p", null, "No account? No Problem")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_o_button, {
                    variant: "jbm-info",
                    outlined: "",
                    onClick: _ctx.checkoutAsGuest
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Continue as guest", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}